import React from 'react';
import TreeViewContainer from '../../Componant/Bonus-Ui/TreeView';

const TreeView = () => {
  return (
    <div className='page-body'>
      <TreeViewContainer />
    </div>
  );
};

export default TreeView;
